// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listLineContainerStyles } from "@conklin/App/Components/MyListsDetails/ListLineContainer";
import { avoidBreakInsidePrintElement, color, xScreen } from "@conklin/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { css } from "styled-components";

listLineContainerStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 32px 132px minmax(0, 700px) minmax(40px, 1fr) minmax(0, 282px);
        width: 100%;
        background: ${color("common.white")};
        padding: 12px 0;
        ${xScreen("lte", "md")} {
            grid-template-columns: 0 103px minmax(0, 255px) minmax(40px, 1fr) minmax(0, 255px);
        }
        ${avoidBreakInsidePrintElement}
        @media print {
            margin: 1px 0; // show borders on print
        }
    `,
};

listLineContainerStyles.checbox = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 1 / 6;
        line-height: 16px;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 6;
            grid-row: 1 / 2;
            padding-bottom: 16px;
        }
    `,
};

listLineContainerStyles.image = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 1 / 6;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
            grid-row: 2 / 5;
        }
    `,
};

listLineContainerStyles.description = {
    css: css`
        grid-column: 3 / 4;
        grid-row: 1 / 5;
        display: inline-flex;
        flex-direction: column;
        ${xScreen("lte", "md")} {
            grid-row: 2 / 4;
            grid-column: 3 / 5;
        }
        ${xScreen("lte", "sm")} {
            grid-column: 3 / 6;
        }
        @media print {
            grid-column: 3 / 5;
            padding-right: 12px;
        }
    `,
};

listLineContainerStyles.price = {
    css: css`
        grid-column: 5 / 6;
        grid-row: 1 / 2;
        ${xScreen("lte", "md")} {
            grid-column: 3 / 4;
            grid-row: 4 / 5;
        }
        ${xScreen("lte", "sm")} {
            grid-column: 3 / 6;
        }
        @media print {
            grid-column: 5 / 6;
            grid-row: 2 / 3;
        }
    `,
};

listLineContainerStyles.actions = {
    css: css`
        grid-column: 5 / 6;
        grid-row: 2 / 3;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 4;
            grid-row: 5 / 6;
            > ${StyledWrapper} {
                max-width: 357px;
            }
        }
        ${xScreen("lte", "sm")} {
            grid-column: 1 / 6;
            > ${StyledWrapper} {
                max-width: 100%;
            }
        }
        @media print {
            grid-column: 5 / 6;
            grid-row: 3 / 5;
        }
    `,
};

listLineContainerStyles.deleteItem = {
    css: css`
        grid-column: 5 / 6;
        grid-row: 3 / 4;
        ${xScreen("lte", "md")} {
            grid-column: 3 / 4;
            grid-row: 6 / 7;
        }
        ${xScreen("lte", "sm")} {
            grid-column: 3 / 6;
            z-index: 1;
        }
        @media print {
            grid-column: 1 / 6;
            grid-row: 7 / 8;
        }
    `,
};

listLineContainerStyles.notes = {
    css: css`
        grid-column: 3 / 4;
        grid-row: 5 / 6;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 4;
            grid-row: 6 / 7;
        }
        ${xScreen("lte", "sm")} {
            grid-column: 1/ 7;
        }
        @media print {
            grid-column: 1 / 6;
            grid-row: 6 / 7;
        }
    `,
};
